import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {RouterService} from './router.service';

@Injectable({ providedIn: 'root' })
export class AppNavigationHistoryService {
  private readonly STORAGE_KEY = 'app_nav_history';
  private readonly MAX = environment.maxNavHistory;

  private urls: string[] = [];
  private goingBack = false;

  constructor(
    private router: Router,
    private routerService: RouterService,
  ) {
    this.urls = this.loadFromSession();

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (this.goingBack) {
          this.goingBack = false;
          return;
        }
        if (this.routerService.isHomePage()) {
          this.clear();
          return;
        }
        const url = this.routerService.withBrandingParam(e.urlAfterRedirects);

        // Avoid duplicates if the same URL is emitted consecutively
        if (this.urls.length === 0 || this.urls[this.urls.length - 1] !== url) {
          this.urls.push(url);
          if (this.urls.length > this.MAX) this.urls.shift();
          this.saveToSession();
        }
      });
  }

  canGoBack(): boolean {
    return this.urls.length >= 2;
  }

  previousUrl(): string | null {
    return this.canGoBack() ? this.urls[this.urls.length - 2] : null;
  }

  popCurrent(): void {
    if (this.urls.length) {
      this.urls.pop();
      this.saveToSession();
    }
    this.goingBack = true;
  }

  clear(): void {
    this.urls = [];
    this.goingBack = false;
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  private loadFromSession(): string[] {
    try {
      const raw = sessionStorage.getItem(this.STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((x) => typeof x === 'string').slice(-this.MAX);
    } catch {
      return [];
    }
  }

  private saveToSession(): void {
    try {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.urls));
    } catch {

    }
  }
}
